import { View, Text, Platform } from "react-native";
import type { ReactNode } from "react";
import { EMBER } from "../../../onboarding/theme";
import { useTranslations } from "@src/packages/i18n";
import { SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE } from "../ScreenTitle";
import { colors } from "@louise/theme/tokens";

export default function PharmacyHeader({
  rightAccessory,
}: {
  rightAccessory?: ReactNode;
}) {
  const t = useTranslations();

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 12,
        }}
      >
        <Text
          className="font-dm-sans"
          style={{
            flex: 1,
            fontSize: 38,
            fontWeight: "700",
            color: colors.deepBrown,
            lineHeight: 42,
            letterSpacing: -0.5,
            ...(Platform.OS === "web" && {
              ...SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }),
          }}
        >
          {t("access.overview.categories.pharmacy_title")}
        </Text>
        {rightAccessory}
      </View>
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 15,
          color: EMBER.colors.textLight,
          marginTop: 2,
          lineHeight: 21,
        }}
      >
        {t("access.pharmacy.header_subtitle")}
      </Text>
    </>
  );
}
